
    import { defineComponent, onUpdated, ref } from 'vue'

    import vuetifyPlugin from '@/app/plugins/vuetify'
    import i18nPlugin from '@/app/lang'
    import { useVuetify } from '@/common/composables/libs/vuetify'
    import { mountPlayers } from '@/common/util/audio-utils'

    export default defineComponent({
        props: {
            content: {
                type: String,
                required: true
            }
        },
        setup () {
            const vuetify = useVuetify()
            const element = ref()

            onUpdated((): void => {
                mountPlayers(element.value, vuetify.theme.dark, i18nPlugin, vuetifyPlugin)
            })

            return {
                element
            }
        }
    })
